import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=45777b3a&scoped=true&"
import script from "./Documents.vue?vue&type=script&lang=ts&setup=true&"
export * from "./Documents.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./Documents.vue?vue&type=style&index=0&id=45777b3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45777b3a",
  null
  
)

export default component.exports